import { PatchSubstitutionPartParams } from '@/modules/adjusterReportModules/IncidentParticipants/queries/patchSubstitutionPart/patchSubstitutionPartQuery.type';
import { PatchSubstitutionPartQueryFunction } from '@/modules/adjusterReportModules/IncidentParticipants/queries/patchSubstitutionPart/patchSubstitutionPartQueryFunction';
import { useMutation } from '@tanstack/react-query';

export const usePatchSubstitutionPartQueryOption = () => {
  return useMutation({
    mutationFn: (params: PatchSubstitutionPartParams) =>
      PatchSubstitutionPartQueryFunction(params),
    mutationKey: ['addSubstitutionPartQueryOption'],
  });
};
